export default "__VITE_ASSET__D_5c8t0___"